import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  Select,
  Tooltip,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    root: {
      flexGrow: 1,
      borderBottom: '1px solid',
      borderBottomColor: '#bdbdbd',
      marginTop: 5,
    },
    demo: {
      backgroundColor: '#f5f5f5',
    },
  }),
);

export default function ({ label, open, close }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const state = useSelector(
    (state: RootStateOrAny) => state.NewOperationHoursReducer,
  );
  const openValue = state[open] ? state[open] : '';
  const closeValue = state[close] ? state[close] : '';

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={4} md={4}>
          <div className={classes.demo}>
            <List>
              <ListItem style={{ padding: "0px 16px 0px 16px" }}>
                <ListItemText primary={label} />
              </ListItem>
              <ListItem style={{ padding: "0px 16px 0px 16px" }}>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography
                      variant="caption"
                      display="inline"
                      style={{
                        background: "#d4d8d9",
                        color: "black",
                        borderRadius: "10px",
                        padding: "5px"
                      }}>
                      {t('operationHours.daypart')}
                    </Typography>
                  }
                />
              </ListItem>
            </List>
          </div>
        </Grid>
        <Grid item xs={2} md={2}></Grid>
        <Grid item xs={3} md={3}>
          <Tooltip title={''}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel htmlFor="outlined-time-native-simple">
                {t('operationHours.start')}
              </InputLabel>
              <Select
                style={{ pointerEvents: 'none', color: 'grey' }}
                native
                value={openValue}
                label={t('operationHours.start')}
                inputProps={{
                  name: 'availableTimes',
                  id: 'outlined-time-native-simple',
                }}
                disabled={true}
              >
                {<option value={openValue}>{openValue}</option>}
              </Select>
            </FormControl>
          </Tooltip>
        </Grid>
        <Grid item xs={3} md={3}>
          <Tooltip title={''}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel htmlFor="outlined-time-native-simple">
                {t('operationHours.close')}
              </InputLabel>
              <Select
                style={{ pointerEvents: 'none', color: 'grey' }}
                native
                value={closeValue}
                label={t('operationHours.close')}
                inputProps={{
                  name: 'availableTimes',
                  id: 'outlined-time-native-simple',
                }}
                disabled={true}
              >
                {<option value={closeValue}>{closeValue}</option>}
              </Select>
            </FormControl>
          </Tooltip>
        </Grid>
      </Grid>
    </div>
  );
}
